import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../globalServices/permission.service';

export const coBorrowerSignupGuard: CanActivateFn = () => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  if (permissionService.isAuthenticated()) {
    // Return 403 for admins accessing a co-borrower invitation link
    if (!permissionService.hasRole('Applicant')) {
      return router.parseUrl('/error?status=403');
    }
    // Return 403 for a primary borrower accessing a co-borrower invitation link.
    const applicationRoles = permissionService.getBorrowerApplicationRoles();
    if (applicationRoles && applicationRoles.hasApplicant && !applicationRoles.hasCoBorrower) {
      return router.parseUrl('/error?status=403');
    }
    return router.parseUrl(permissionService.getDefaultPostAuthUrl());
  }

  return true;
};
